import { PureComponent } from 'react';
import { Switch, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  marginRight: '10px',
  '& .MuiSwitch-switchBase': {
    padding: 2,
    color: theme.palette.grey[500],
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
}));

interface SwitchButtonProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
}

export default class SwitchButton extends PureComponent<SwitchButtonProps> {
  render() {
    return (
      <FormControlLabel
        control={
          <AntSwitch disabled={this.props.disabled} checked={this.props.checked} onChange={this.props.onChange} />
        }
        label={this.props.label}
      />
    );
  }
}
